import { SearchOutlined } from '@ant-design/icons';
import {  Button, Input, Space, Table } from 'antd';
import  React, { useRef, useState } from 'react';

import { useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import commonService from "../../../api/common.service";







const ApiList = () => {
   
    
    const [apiList, setApiList] = useState([]);
    
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);


    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
      };


      const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div
            style={{
              padding: 8,
            }}
          >
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{
                marginBottom: 8,
                display: 'block',
              }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Search
              </Button>
              <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Reset
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({
                    closeDropdown: false,
                  });
                  setSearchText(selectedKeys[0]);
                  setSearchedColumn(dataIndex);
                }}
              >
                Filter
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined
            style={{
              color: filtered ? '#1890ff' : undefined,
            }}
          />
        ),
        onFilter: (value, record) =>
          record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });    
  
  
  
  
  
    const columns = [
        {
            title: 'Module',
            dataIndex: 'module_name',
            key: 'module_name',
             ...getColumnSearchProps('module_name'),
          },
      {
        title: 'Url',
        dataIndex: 'api_url',
        key: 'api_url',
        ...getColumnSearchProps('api_url'),
        
      },
      {
        title: 'Method',
        dataIndex: 'method',
        key: 'method',
       
        
      },
      {
        title: 'Body',
        dataIndex: 'body',
        key: 'body',
       
      },

      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        
      },{
        title: 'Header',
        dataIndex: 'header',
        key: 'header',
        // render:(x) => {return (<>
        //     <div><pre>{x}</pre></div>
        // </>) }
      },
      {
        title: 'Params',
        dataIndex: 'params',
        key: 'params',
        // render:(x) => {return (<>
        //     <div><pre>{x}</pre></div>
        // </>) }
      },
      {
        title: 'Response',
        dataIndex: 'response',
        key: 'response',
        // render:(x) => {return (<>
        //     <div><pre>{x}</pre></div>
        // </>) }
        
      },
      
      
     
     
    ];
  
  
    useEffect(() => {
        commonService.getApiList().then((res) => {
            console.log(res.data.response_data);
            setApiList(res.data.response_data);
        });
    }, [])
  
    return (
      <>
        <Table columns={columns} rowKey='api_id' dataSource={apiList} size="small" scroll={{
      x: 'auto',
    }}/>
  
       
  
      </>
    );
}

export default ApiList